import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import FindYourVehicleForm from '../../../components/siteadmin/FindYourVehicleForm/FindYourVehicleForm';
import Loader from '../../../components/Loader/Loader';

import getFindYourVehicleBlock from './getFindYourVehicleBlock.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './FindYourVehicleBlock.css';

const FindYourVehicleBlock = (props) => {

  const { data: { getFindYourVehicleBlock, loading }, title } = props;
  let settingsCollection = {};
  let dynamicSettings = {};

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    getFindYourVehicleBlock && getFindYourVehicleBlock.results && getFindYourVehicleBlock.results.length > 0 && getFindYourVehicleBlock.results.map((item, key) => {
      item.value != null && (settingsCollection[item.name] = item.value)
      item?.dynamicFindYourVehicleBlock?.length > 0 && item.dynamicFindYourVehicleBlock.map((dynamicItem) => {
        dynamicSettings[dynamicItem.language] = {
          ...dynamicSettings[dynamicItem.language],
          language: dynamicItem.language,
          [item.name]: dynamicItem.value
        }
      })
    });
    settingsCollection.dynamicFindYourVehicleBlock = Object.keys(dynamicSettings).length > 0 ? Object.keys(dynamicSettings).map(item => dynamicSettings[item]) : [{
      language: 'en',
      heading: settingsCollection?.heading,
      buttonLabel: settingsCollection?.buttonLabel,
      content1: settingsCollection?.content1,
      content2: settingsCollection?.content2,
      content3: settingsCollection?.content3,
      content4: settingsCollection?.content4,
      content5: settingsCollection?.content5
    }];
    return <FindYourVehicleForm initialValues={settingsCollection} title={title} />
  }
}

FindYourVehicleBlock.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getFindYourVehicleBlock: PropTypes.object,
  })
};

export default compose(
  withStyles(s),
  withQuery(getFindYourVehicleBlock, {
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
)(FindYourVehicleBlock);
